<script setup>
import { computed, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const activeCssGroupName = computed(() => store.state.themes.activeCssGroupName);
const cssGroupNames = computed(() => store.state.themes.cssGroupNames);
const tableName = computed(() => store.state.themes.tableName);
const noneGroupName = computed(() => store.state.themes.noneGroupName);
const allGroupName = computed(() => store.state.themes.allGroupName);

const show = computed(() => tableName.value === 'themes_css');

const groupNames = computed(() => {
    if (!cssGroupNames.value) return [];

    // Using spread operator is cleaner and faster than JSON parse/stringify for simple arrays
    return [
        allGroupName.value,
        noneGroupName.value,
        ...cssGroupNames.value
    ];
});

// --- Methods ---

const setActiveCssGroupName = (groupName) => {
    store.dispatch('themes/setActiveCssGroupName', groupName);
};
</script>

<template>
    <div v-if="show && cssGroupNames" class="dropdown">
        <button class="btn btn-light btn-sm dropdown-toggle" data-bs-toggle="dropdown" type="button">
            {{ activeCssGroupName }}
        </button>
        <div class="dropdown-menu">
            <button
                type="button"
                v-for="groupName in groupNames"
                :key="groupName"
                :class="{ 'active': groupName === activeCssGroupName }"
                class="dropdown-item"
                @click="setActiveCssGroupName(groupName)"
            >
                {{ groupName }}
            </button>
        </div>
    </div>
</template>